import { useCurrentTime } from '@/hooks/useCurrentTime'

type ShellHeaderClockProps = {
  variant?: 'light' | 'dark'
  className?: string
}

export function ShellHeaderClock({ variant = 'light', className = '' }: ShellHeaderClockProps) {
  const { currentTime } = useCurrentTime()

  const timeLabel = currentTime.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
  })

  /*
   * Число и месяц — одним вызовом, а не по частям: отдельно взятый месяц
   * приходит в именительном падеже («16 Октябрь»), вместе с числом — в
   * родительном («16 октября 2026 г.»).
   */
  const dateLabel = currentTime.toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
  const weekdayRaw = currentTime.toLocaleDateString('ru-RU', { weekday: 'long' })
  // С заглавной только первая буква: `capitalize` поднимал и «г.» в «Г.».
  const weekday = weekdayRaw.charAt(0).toUpperCase() + weekdayRaw.slice(1)

  const isLight = variant === 'light'
  const timeClass = isLight ? 'text-white' : 'text-gray-900'
  const datePrimaryClass = isLight ? 'text-white/90' : 'text-gray-700'
  const dateSecondaryClass = isLight ? 'text-white/75' : 'text-gray-500'

  return (
    <div
      className={`flex items-center gap-3 ipad:gap-4 pointer-events-none select-none ${className}`}
    >
      <span
        className={`text-xl ipad:text-[2.25rem] font-light tabular-nums leading-none tracking-wide shrink-0 ${timeClass}`}
      >
        {timeLabel}
      </span>
      {/* Дата — только когда шапке хватает ширины: на iPad в книжной ориентации она налезала на кнопки справа. */}
      {/*
       * Дата в одну строку и не сжимается: с `min-w-0` колонка ужималась в
       * шапке и дата ломалась в столбик по слову («16 / Октябрь / 2026 / Г.»).
       * Видна от 1100 px: на 1024 (iPad Pro 12.9 в книжной) шапке тесно, и она
       * наезжала на колокольчик и «Быструю связь».
       */}
      <div className="text-left leading-snug shrink-0 whitespace-nowrap hidden min-[1100px]:block">
        <p className={`text-xs ipad:text-sm ${datePrimaryClass}`}>{dateLabel}</p>
        <p className={`text-xs ipad:text-sm ${dateSecondaryClass}`}>{weekday}</p>
      </div>
    </div>
  )
}
